import { useContext } from 'react';
import { UserContext } from '@lib/contexts/UserProvider';
import { LiveCodesAvailableCard } from './LiveCodesAvailableCard';
import { LiveClaimTrialCard } from './LiveClaimTrialCard';
import useFlags from '@lib/hooks/useFlags';

export const LiveEventsExtraCards = () => {
  const [currentUser] = useContext(UserContext);
  const [flags] = useFlags();

  if (currentUser?.trial && flags?.enable_manual_trial) {
    return <LiveClaimTrialCard />;
  } else {
    return <LiveCodesAvailableCard />;
  }
};
